import React from 'react'
import { Input, InputProps } from '../input/Input'

export const Textarea = (props: InputProps) => <Input multiline {...props} />

export default Textarea
